import axios from 'axios';
import { setupAxiosInterceptor } from './auth/axiosConfig';
import config from './config';

// API instance for Connectors cross-integration endpoints.
// Separate instance from linearApi / composioApi because the endpoint is
// multi-source (Linear installations + PostOffice aggregation).
const connectorsApi = axios.create({
  baseURL: config.API_BASE_URL + '/cellcog/connectors',
});

setupAxiosInterceptor(connectorsApi);

/**
 * Get per-delegation-host connection state + task counts for the current user.
 *
 * Response shape:
 *   {
 *     openclaw:    { connected: bool, task_count: int },
 *     linear:      { connected: bool, task_count: int, installation_count: int },
 *     cursor:      { connected: bool, task_count: int },
 *     claude_code: { connected: bool, task_count: int },
 *     other:       { connected: bool, task_count: int, agent_names: string[] },
 *     mcp:         { connected: bool, task_count: int },   // CEL-2750; absent on older backends → treated as 0
 *   }
 *
 * Used by:
 *   - /connectors hub's Your Connections pills
 *   - /delegate agent grid (green dots)
 *   - /delegate/<agent> detail page headers
 *   - /delegate/other page
 */
export const getDelegationStats = () => {
  return connectorsApi.get('/delegation-stats');
};

export default connectorsApi;
